export default "__VITE_ASSET__DzlFC9gY__"